import React, { useState } from "react";
import { FaCirclePlay } from "react-icons/fa6";
import { Helmet } from "react-helmet-async";

function ContactPage() {
  const [videoSrc, setVideoSrc] = useState("");

  const handlePlayVideo = () => {
    setVideoSrc("/videos/work.mp4");
  };

  return (
    <div>
      <Helmet>
        <title>Nos Services - MOSA Ingénierie</title>
        <meta
          name="description"
          content="Découvrez nos services en ingénierie et économie de la construction : études, suivi de chantier et plus encore."
        />
      </Helmet>

      <div className="bg-[#F2F2F2] h-full flex flex-col lg:flex-row justify-center items-center px-8 lg:px-24 py-20 lg:py-40 shadow-2xl">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/2">
            <div className="p-8">
              <h1 className="text-3xl lg:text-6xl font-bold mb-4 tracking-wider text-center">
                <span className="text-[#0A827D]">Découvrer nos métiers </span>
              </h1>
              <p className="text-base lg:text-lg text-gray-700 mb-8 text-justify pt-4 tracking-wider">
                Venez en savoir plus sur nos différentes missions au sein de
                MOSA Ingénierie.
              </p>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="p-4 relative h-60 lg:h-96">
              {videoSrc ? (
                <iframe
                  src={videoSrc}
                  title="presentation des services"
                  className="w-full h-full bg-gray-700 shadow-lg transition duration-500 ease-in-out transform border-8 border-[#007E79]"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className="relative w-full h-full">
                  <img
                    src="/images/thumbnail-services.png"
                    alt="Video Thumbnail"
                    className="w-full h-full object-cover rounded-lg shadow-lg"
                  />
                  <button
                    onClick={handlePlayVideo}
                    className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-lg"
                  >
                    <FaCirclePlay className="h-12 w-12  text-[#F2F2F2] shadow-2xl rounded-full" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white shadow-2xl px-4 lg:px-24 flex flex-col lg:flex-row items-center lg:items-stretch">
        <div className="w-full lg:w-1/3 bg-[#E8F4F3] p-8 lg:p-16 flex flex-col justify-center items-center lg:mt-0 mt-3">
          <img
            src="/images/service1.png"
            alt="logo"
            className="w-24 h-24 lg:w-36 lg:h-36 rounded-full shadow-lg mx-auto my-4 lg:my-8"
          />
          <div className="flex justify-center">
            <h1 className="text-[#0A827D] text-xl lg:text-4xl font-bold mb-2 lg:mb-8 text-center">
              Economie de la construction
            </h1>
          </div>
          <div>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              En tant qu’économiste de la construction, notre mission est
              d’assurer la réussite financière de votre projet. Spécialisé dans
              l’évaluation des coûts de construction, nous vous permettons
              d’avoir une estimation précise de votre futur projet.
            </p>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              Nous vous proposons des solutions adaptées à votre budget et en
              accord avec vos besoins et désirs.
            </p>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              Nous sommes aussi présents lors de la consultation d’entreprise
              afin d’établir les pièces écrites et vous aidez à faire le
              meilleur choix d’entreprise pour votre projet.
            </p>
          </div>
        </div>

        <div className="w-full lg:w-1/3 p-8 lg:p-16 flex flex-col justify-center items-center">
          <img
            src="/images/service3.png"
            alt="logo"
            className="w-24 h-24 lg:w-36 lg:h-36 rounded-full shadow-lg mx-auto my-4 lg:my-8"
          />
          <div className="flex justify-center">
            <h1 className="text-[#0A827D] text-xl lg:text-4xl font-bold mb-2 lg:mb-8 text-center">
              Maitrise d’oeuvre d’execution
            </h1>
          </div>
          <div>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              En tant que maitre d’oeuvre d’exécution, notre rôle est d’assurer
              la bonne exécution des travaux jusqu’à la livraison.
            </p>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              Nous veillons à ce que les travaux réalisés respectent les normes
              et les spécificités de votre projet. Nous assurons aussi un suivi
              financier afin que les coûts de construction respectent votre
              budget établi.
            </p>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              Enfin, nous gérons les imprévues liés au chantier en trouvant des
              solutions efficaces pour minimiser les perturbations et surcouts
              éventuels.
            </p>
          </div>
        </div>

        <div className="w-full lg:w-1/3 bg-[#E8F4F3] p-8 lg:p-16 flex flex-col items-center lg:mb-0 mb-3">
          <img
            src="/images/service2.png"
            alt="logo"
            className="w-24 h-24 lg:w-36 lg:h-36 rounded-full shadow-lg mx-auto my-4 lg:my-8"
          />
          <div className="flex justify-center">
            <h1 className="text-[#0A827D] text-xl lg:text-4xl font-bold mb-2 lg:mb-8 text-center">
              Ordonnencement pilotage plannification
            </h1>
          </div>
          <div>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              En tant qu’OPC, nous sommes chargés de planifier et d’organiser le
              déroulement du chantier pour vous livrer votre bâtiment dans les
              délais.
            </p>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              Pour cela, nous supervisons et contrôlons l’avancement des travaux
              afin de respecter le planning établi et éviter les retards et
              décalage.
            </p>
            <p className="text-sm lg:text-lg text-gray-700 py-1 lg:py-3">
              Enfin, nous coordonnons l’intervention des entreprises pour que le
              chantier se déroule de la manière la plus fluide possible.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
